module.exports = __webpack_public_path__ + "media/newstyle/images/banner_partner_stores-e00e0832dfb2d61fa6d399fc85117f83.png";